import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import CompanionCardSelection from './CompanionCardSelection';

interface CompanionCardSelectionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CompanionCardSelectionModal: React.FC<CompanionCardSelectionModalProps> = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence key="companion-card-selection-modal">
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-2 sm:p-4"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            className="bg-white rounded-xl shadow-2xl w-full max-w-7xl max-h-[95vh] sm:max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="sticky top-0 bg-gradient-to-r from-purple-600 to-pink-600 text-white p-3 sm:p-4 flex justify-between items-center rounded-t-xl z-10">
              <h1 className="text-lg sm:text-2xl font-bold flex items-center gap-2">
                🎴 Mysteriöse Karten-Auswahl
              </h1>
              <button
                onClick={onClose}
                className="text-white hover:text-gray-200 transition-colors duration-200 text-xl sm:text-2xl p-2 touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center rounded-lg hover:bg-white/10"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="overflow-hidden max-h-[calc(95vh-80px)] sm:max-h-[calc(90vh-80px)]">
              <CompanionCardSelection />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CompanionCardSelectionModal; 